import axios from 'axios';
import Vue from 'vue';

export default class Axios {
	_token = '';

	constructor() {
		this.axios = axios.create({
			transformRequest: [(data, headers) => {
				const gestios = Vue.prototype.$gestios;
				const settings = Vue.prototype.$settings;

				if (gestios.project.name) headers['g-project'] = gestios.project.name;
				if (gestios.profile.API) headers['g-token'] = gestios.profile.API;
				if (settings.env) headers['g-env'] = settings.env;

				return data;
			}]
		});

		this.request();
		this.response();
	}

	request() {
		this.axios.interceptors.request.use(config => {
			config.baseURL = Vue.prototype.$app.paths.lambda
			return config;
		});
	}

	response() {
		this.axios.interceptors.response.use(
			response => {
				return {
					ok: true,
					data: response.data
				};
			},
			error => {
				let response = error.response !== undefined ? error.response : null;
				let code = response ? response.status : 0;
				let message = response ? '' : 'No se pudo conectar al sistema Lambda';
				let errors = [];

				if(!response){
					code = 0;
					message = 'El servicio Lambda no está disponible';
				}else if (response.data.error !== undefined) {
					if (code === 400) {
						message = 'No se han recibido los parámetros correctos';
						errors = response.data.error;
					} else {
						message = response.data.error;
					}
				} else if (response.data.error === undefined) {
					switch (code) {
						case 404:
							message = 'No se encontraron resultados';
							break;

						case 400:
							message = 'No se han recibido los parámetros correctos';
							break;

						case 500:
							message = 'Ocurrió un error interno. Contacte con soporte';
							break;

						case 401:
							message = 'No está autenticado';
							break;

						case 403:
							message = 'Acceso no autorizado al recurso';
							break;

						default:
							message = 'Ocurrió un error desconocido';
					}
				}

				return {
					ok: false,
					response: response,
					code,
					message,
					errors,
				};
			}
		);
	}
}
